import React from "react";
import './sundryPdfStyle.css'

export default class ComponentToPrint extends React.Component {
    render() {
        const selectedSearchValues = this.props.selectedSearchValues
        const reportData = (this.props.reportData).slice();
        const originalDataCount = reportData.slice()
        const jobs = this.props.jobs

        const chunkedData = this.chunkArray(reportData, 25);
        const chunkedTotalValues = this.calculateChunkTotals(reportData, 25)
        const chunkOTHTotals = this.calculateChunkOTHTotals(reportData, 25)
        return (
            <div style={{ width: '100%', marginTop: -40 }}>
                {chunkedData.map((chunk, index) => (
                    <div className="pdf-head">
                        <h3 style={{ fontWeight: "bold" }}><center>{selectedSearchValues.group}</center></h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div><b>Sundry / Factory Check List</b></div>
                            <div>{jobs[selectedSearchValues.jobTypeID]}</div>
                        </div>
                        <div className="pdf-root">
                            <table className="head-table">
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Initial of Field Officer</th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th>Date</th>
                                        <th>{selectedSearchValues.date}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Estate</td>
                                        <td>{selectedSearchValues.estate}</td>
                                        <td colSpan={5}>Name and Initial of Field Asst.</td>
                                    </tr>
                                    <tr>
                                        <td>Division</td>
                                        <td>{selectedSearchValues.division}</td>
                                        <td colSpan={3}>No. of Workers at Musters : {index == 0 ? originalDataCount.length : ''}</td>
                                        <td colSpan={2}>Muster Distributed by :(Sign)</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Field Officer:</td>
                                        <td colSpan={3}>Supervisor</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="data-table" id="data-table">
                                <thead>
                                    <tr style={{ height: '30px' }}>
                                        <th style={{ width: '20px' }}></th>
                                        <th style={{ width: '60px' }}>E.P.F <br />No</th>
                                        <th>Name</th>
                                        <th style={{ width: '100px' }}>Field <br />No.</th>
                                        <th style={{ width: '60px' }}>Work <br />Code</th>
                                        <th style={{ width: '60px' }}>Work <br />Unit</th>
                                        <th style={{ width: '60px' }}>Work <br />Qty</th>
                                        <th style={{ width: '40px' }}>Day</th>
                                        <th style={{ width: '60px' }}>OT <br />Job Code</th>
                                        <th style={{ width: '40px' }}>OT <br />Hours</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((row, index) => (
                                        <tr style={{ fontSize: '8px' }}>
                                            <td style={{ width: '20px' }}>{index + 1}</td>
                                            <td style={{ width: '50px' }}>{row.registrationNumber}</td>
                                            <td className='table-name-col' style={{ width: '120px' }}>{row.firstName}</td>
                                            <td style={{ width: '50px' }} className='table-name-col'>{row.fieldName}</td>
                                            <td style={{ width: '50px' }}>{row.taskName}</td>
                                            <td style={{ overflow: 'visible' }} align="center">{row.jobTypeName}</td>
                                            <td style={{ width: '50px' }}></td>
                                            {row.progress == 100 ?
                                                <td style={{ width: '50px', borderTop: '1px solid #000000' }}>
                                                    1
                                                </td>
                                                : row.progress == 50 ?
                                                    <td style={{ width: '50px', borderTop: '1px solid #000000' }}>
                                                        0.5
                                                    </td>
                                                    : <td style={{ width: '50px', borderTop: '1px solid #000000' }}>
                                                        -
                                                    </td>}
                                            <td style={{ width: '50px' }}>{row.taskCode == null ? '-' : row.taskCode}</td>
                                            <td style={{ width: '50px' }}>{row.otHours == 0 ? '-' : row.otHours}</td>

                                        </tr>
                                    ))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td><b>Total</b></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{(chunkedTotalValues[index]).toFixed(2)}</td>
                                        <td></td>
                                        <td>{chunkOTHTotals[index] !== 0 ? chunkOTHTotals[index].toFixed(2) : '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <br></br>
                            <table className="summary-table">
                                <thead>
                                    <tr>
                                        <th colSpan={6}>Details of Chemicals/Fertiliser/Other Material used</th>
                                        <td colSpan={4}>Checked by: Supdt./Asst. Supdt./Field/Fact. Officer</td>
                                        <td>Time</td>
                                        <td>Initial</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={2}>Material</td>
                                        <td>Hect.</td>
                                        <td>Work Code</td>
                                        <td>Unit</td>
                                        <td>Qty. Used</td>
                                        <td colSpan={4}>Name</td>
                                        <td>Time</td>
                                        <td>Initial</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td colSpan={4}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td colSpan={4}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td colSpan={4}></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <center style={{ fontSize: '9px' }}>
                            <div className="row pb-0 pt-4">
                                <div className="col"> </div>
                                <div className="col"> </div>
                                <div className="col">Authorized by</div>
                                <div className="col">Checked by</div>
                                <div className="col">Approved by</div>
                            </div>
                            <div className="row pb-0 pt-3">
                                <div className="col">Entered by</div>
                                <div className="col">.......................................... </div>
                                <div className="col">..............................</div>
                                <div className="col">.............................</div>
                                <div className="col">..............................</div>
                            </div>
                            <div className="row pb-0 pt-0">
                                <div className="col"></div>
                                <div className="col"> </div>
                                <div className="col">Asst Supdt.</div>
                                <div className="col">Div.Clerk</div>
                                <div className="col">Supd</div>
                            </div>
                        </center>
                        {chunkedData.length - 1 !== index ? <div className='pagebreak'></div> : <div></div>}
                    </div>
                ))}
            </div>
        )
    }
    chunkArray(array, size) {
        let i = array.length % size == 0 ? 25 : array.length % size
        for (i; i < 25; i++) {
            array.push({ empty: true })
        }
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        return chunkedArr;
    }
    calculateChunkTotals(array, size) {
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        let chunkedDayTotals = []
        let dayTotal = 0
        for (let i = 0; chunkedArr.length > i; i++) {
            for (let j = 0; j < chunkedArr[i].length; j++) {
                dayTotal += chunkedArr[i][j].progress == 100 ?
                    1 : chunkedArr[i][j].progress == 50 ? 0.5 : 0
            }
            chunkedDayTotals.push(dayTotal)
            dayTotal = 0
        }
        return chunkedDayTotals
    }
    calculateChunkOTHTotals(array, size) {
        const chunkedArr = [];
        let index = 0;
        while (index < array.length) {
            chunkedArr.push(array.slice(index, size + index));
            index += size;
        }
        let chunkedDayTotals = [];
        let dayTotal = 0;
        for (let i = 0; i < chunkedArr.length; i++) {
            for (let j = 0; j < chunkedArr[i].length; j++) {
                if (chunkedArr[i][j].hasOwnProperty('otHours') && !isNaN(chunkedArr[i][j].otHours)) {
                    dayTotal += parseFloat(chunkedArr[i][j].otHours);
                }
            }
            chunkedDayTotals.push(dayTotal);
            dayTotal = 0;
        }
        return chunkedDayTotals;
    }
}